@if (application()) {
  <div
    class="application-card"
    [class.no-icon]="!(application() | applicationIcon)"
  >
    @if (application() | applicationIcon) {
      <div class="application-card-img">
        <img
          [ngSrc]="application() | applicationIcon"
          fill
          priority
          [alt]="`${application().kodTech}`"
        />
      </div>
      <div class="application-card-description">
        <div class="application-card-description-code">
          {{ application().kodTech }}
        </div>
        <p
          class="application-card-description-name"
          [pTooltip]="isOverflow() ? application().nazwa! : undefined"
          tooltipPosition="bottom"
          #clamped
        >
          {{ application().nazwa }}
        </p>
      </div>
    } @else {
      <div class="application-card-code-only">
        {{ application().kodTech }}
      </div>
      <p
        class="application-card-description-name"
        [pTooltip]="isOverflow() ? application().nazwa! : undefined"
        tooltipPosition="bottom"
        #clamped
      >
        {{ application().nazwa }}
      </p>
    }
  </div>
}
